import React, { useState, useEffect } from 'react';
import { MessageCircle, X, ChevronLeft, ChevronRight } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

const TestimonialsSection = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const res = await fetch(`${API_URL}/api/testimonials.php`);
        if (res.ok) {
          const data = await res.json();
          setTestimonials(data);
        }
      } catch (e) {
        console.error('Error fetching testimonials:', e);
      } finally {
        setLoading(false);
      }
    };
    fetchTestimonials();
  }, []);

  const openLightbox = (index) => {
    setCurrentIndex(index);
    setSelectedImage(testimonials[index]);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  const goNext = () => {
    const newIndex = (currentIndex + 1) % testimonials.length;
    setCurrentIndex(newIndex);
    setSelectedImage(testimonials[newIndex]);
  };

  const goPrev = () => {
    const newIndex = (currentIndex - 1 + testimonials.length) % testimonials.length;
    setCurrentIndex(newIndex);
    setSelectedImage(testimonials[newIndex]);
  };

  if (loading) return null;
  if (testimonials.length === 0) return null;

  return (
    <section id="testimonials" className="testimonials-section">
      <div className="section-container">
        <span className="section-label">UTISCI</span>
        <h2 className="testimonials-title">ŠTA KAŽU NAŠI KUPCI</h2>
        <p className="testimonials-subtitle">Pogledajte prave utiske naših zadovoljnih kupaca</p>
        
        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div 
              key={testimonial.id} 
              className="testimonial-card"
              onClick={() => openLightbox(index)}
            >
              <div className="testimonial-image-wrapper">
                <img 
                  src={testimonial.image_url} 
                  alt={testimonial.caption || 'Utisak kupca'} 
                  loading="lazy"
                />
                <div className="testimonial-overlay">
                  <MessageCircle size={24} />
                  <span>Pogledaj</span>
                </div>
              </div>
              {testimonial.caption && (
                <p className="testimonial-caption">{testimonial.caption}</p>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {selectedImage && (
        <div className="lightbox-overlay" onClick={closeLightbox}>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <button className="lightbox-close" onClick={closeLightbox}>
              <X size={24} />
            </button>
            
            {testimonials.length > 1 && (
              <>
                <button className="lightbox-nav prev" onClick={goPrev}>
                  <ChevronLeft size={32} />
                </button>
                <button className="lightbox-nav next" onClick={goNext}>
                  <ChevronRight size={32} />
                </button>
              </>
            )}
            
            <img 
              src={selectedImage.image_url} 
              alt={selectedImage.caption || 'Utisak kupca'} 
            />
            
            {selectedImage.caption && (
              <p className="lightbox-caption">{selectedImage.caption}</p>
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default TestimonialsSection;
